import React from 'react'

type Props = {}

function PriceList({}: Props) {
  return (
    <div>Price List</div>
  )
}

export default PriceList